$(document).ready( function () {

  $item = null;
  $cartSignaturePopup = $('.cart-signature-popup');

  window.triggerSignatureForm = function ($input) {    
    
      // If the value wasn't changed, then we just return.
      if ( $input.val() == $input.data('quantity-old') || $input.val() < 1 ) return;

      var line = $input.closest('.cart__card');
      $item = line;

      // If it doesn't require signature, we just ignore it.
      if ( !line.data('require-signature')) return;

      var item = line.data('item');

      existing = [];
      var regex = /SignatureFirstName(\d+)/g;
      for (var key in item.properties ) {

        var matches = regex.exec( key );
        console.log({matches});
        if ( matches ) {

          existing.push({
            first_name: item.properties['SignatureFirstName' + matches[1]],
            last_name: item.properties['SignatureLastName' + matches[1]],
            email: item.properties['Email' + matches[1]],
          });
        }
      }

      $cartSignaturePopup.trigger('cart.popup.open', [ $input.val(), existing, $input ]);
      return false;
  }


  $cartSignaturePopup.find('button.confirm').click(function (event) {
      var valid = validateSignatures();
      if (!valid) return;

      $item = $item || $('form.product-form');

      // 1. We remove the existing Item
      // 2. We add the new item with the corresponding signatures.
      // 3. We reload the page.
      var variant_id = $item.data('variant-id') || $('#variant-selector').val()  || $('.cart__item.openForm').data('item').variant-id;
      var quantity = $item.find('input[name=quantity]').val() || $('.cart__item.openForm .cart__item-quantity input').val();
      var properties = {};
  
      $cartSignaturePopup.find('.registrants fieldset').each( function (k, v) {
        properties['SignatureFirstName' + (k + 1)] = $(this).find('input[name*=SignatureFirstName]').val();
        properties['SignatureLastName' + (k + 1)] = $(this).find('input[name*=SignatureLastName]').val();
        properties['Email' + (k + 1)] = $(this).find('input[type=email]').val();
        properties['_duplicates_code'] = Date.now();
      });

    console.log($('.cart__item.openForm').length)
  
        if ($('.cart__item.openForm').length) {
          $.post('/cart/change.js', {quantity: 0, id: $item.data('cart-item') }, function() {
            $.post('/cart/add.js', { quantity: quantity, id: variant_id, properties: properties }, function ( response ) {
                location.reload();
            }, 'json');
          }, 'json');
        } else {
          $.post('/cart/add.js', { quantity: quantity, id: variant_id, properties: properties }, function ( response ) {
            location.reload();
          }, 'json');
        }
  });


  function validateSignatures() {

    // Validations.
    // The first step is to remove any signature validation we find.
    $cartSignaturePopup.find('.signature-validation').remove();

    var valid = true;
    if ( $isSignaturePopupOpened ) {

      var $cart = {};
      var $emailsList = [];

      // Syncronously getting the cart.
      $.ajax({
          url: '/cart.js',
          method: 'GET',
          dataType: 'json',
          async: false,
          success: function( cart ) {
              $cart = cart;
          }
      });

      $cartSignaturePopup.find('input').each( function (k, v) {

          var $input = $(this);

          if ($input.val() == '') {
            $input.after('<p class="signature-validation">This field cannot be left blank.</p>');
            valid = false;
            return true;
          }

          if ($input.val() != '' && $input.attr('type') == 'email' && !isValidEmail( $input.val() )) {
            $input.after('<p class="signature-validation">This field must be a valid email address</p>');
            valid = false;
            return true;
          }

          if ( $input.attr('type') == 'email' ) {

              var $email = $input.val();

              if( $emailsList.indexOf( $email ) > -1 ) {
                  console.log ($emailsList);
                  $input.after('<p class="signature-validation">This email address is already used</p>');
                  valid = false;
                  return true;
              }

              $emailsList.push( $email );
              $( $cart.items ).each( function (j, l) {
                const pageProduct = $('.product-blocks[data-product]').data('product');
                const cartProduct = $('.cart__item.openForm').data('item');
                const product = pageProduct || cartProduct

                console.log(product)
                
                 if ( l.product_id !== product.id ) return true;


                 var regex = /Email(\d+)/g;
                 for ( var key in l.properties ) {
                      if ( regex.exec( key ) ) {
                          if ( l.properties[key] == $email ) {
                              $input.after('<p class="signature-validation">This email address is already used in another item added to cart.</p>');
                              valid = false;
                              return false;
                          }
                      }
                 }
              });
          }


      });


    } else {
        if ($singleSignature.val() == '') {
          $singleSignature.after('<p class="signature-validation">This field cannot be left blank.</p>');
          valid = false;
        }
    }


    return valid;

  }


  function isValidEmail( address ) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(address);
  }


})
